import React from "react";
import CategoryProductItem from "./CategoryProductItem";
import { CategoryProduct } from "../../../domain/entities/CategoryProduct";

interface CategoryProductProps {
    categories: CategoryProduct[];
}

const CategoryProductList: React.FC<CategoryProductProps> = ({categories}) => {
    return (
        // Main container
        <div className="w-full mx-auto px-4 md:px-12 lg:px-12 py-8 md:py-12">
            {/* Heading */}
            <h4 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-8 font-poppins">
                Produk Kami
            </h4>

            {/* Scroll container with position relative for overlay positioning */}
            <div className="relative">
                {/* Scrollable area with no padding to prevent cropping */}
                <div className="overflow-x-auto md:scroll-smooth scrollbar-hide">
                    {/* Content wrapper with padding to create space from edges */}
                    <div className="flex flex-col md:inline-flex md:flex-row gap-6 md:gap-8 px-4">
                        {categories.map((categoryProduct) => (
                            <div 
                                key={categoryProduct.id} 
                                className="w-full md:w-96 flex-shrink-0 mb-6"
                            >
                                <CategoryProductItem 
                                    categoryProduct={categoryProduct} 
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoryProductList;